import ApiService from "@/core/services/api.service";
import {consultarRelacaoFluxo} from '../consultaRelacaoFluxo';
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getCobrancas(context, dados) {
    return new Promise(resolve => {
			if(JwtService.getToken()) {
				ApiService.setHeader();
				ApiService.post("cobrancas/access/listar", dados).then(({ data }) => {
						resolve(data);
				});
			}
    });
  },
	getCobrancasProtocolos(context, dados){
		return new Promise(resolve => {
			if (JwtService.getToken()) {
				ApiService.setHeader();
				ApiService.post("cobrancas/access/listaCobrancasProtocolos", dados).then(({ data }) => {
								resolve(data);
				});
			}
		});
	},
	getCobrancasFaturamentos(context, dados){
		return new Promise(resolve => {
			if (JwtService.getToken()) {
				ApiService.setHeader();
				ApiService.post("cobrancas/access/listarFaturamentoPagamento", dados).then(({ data }) => {
								resolve(data);
				});
			}
		});
	},
	getCobranca(context, dados) {
		return new Promise(resolve => {
			if (JwtService.getToken()) {
				ApiService.setHeader();
				ApiService.post("cobrancas/access/obter", {ID_COBRANCA: dados.id, componente: dados.componente}).then(({ data }) => {
					resolve(data);
				});
			}
		});
	},    
    deleteCobranca(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("cobrancas/access/excluir", {ID_COBRANCA: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    postCobranca(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("cobrancas/access/salvar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },    
    deleteCobrancaProtocolo(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("cobrancas/access/excluirProtocolo", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    postCobrancaProtocolo(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("cobrancas/access/salvarProtocolo", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getCobrancaFluxoDeCaixa(context, dados) {
        return consultarRelacaoFluxo('cobrancas/access/listarCobrancaPorFluxoDeCaixa', dados);
    },
    getFatPagFluxoDeCaixa(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("cobrancas/access/listarFatPagPorFluxoDeCaixa",dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    postCobrancaFatPag(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("cobrancas/access/salvarFatPag", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

export default {
  state,
  actions,
  mutations,
  getters
};
